// Defining remote entries in webpack config will load all the remoteEntry.js files upfront.
// instead we're dynamically loading them in app/remoteHostComponent.tsx
// https://github.com/webpack/webpack/issues/11033#issuecomment-1038772979
import configuration from "./configuration";
import { claimPageUrl } from "./constants";

const isDev = configuration.Environment === "Development";

export interface Remote {
  scope: string;
  url: string;
  path: string;
  module: string;
}

export const remotes: Remote[] = [
  {
    path: "https://settings-businessapp.b2b.tp-local.com:3001",
    url: "settings",
    scope: "settings",
  },
  {
    path: "https://benchmark-businessapp.b2b.tp-local.com:3002",
    url: "benchmark",
    scope: "benchmark",
  },
  {
    path: "https://dashboard-businessapp.b2b.tp-local.com:3005",
    url: "dashboard",
    scope: "dashboard",
  },
  {
    path: "https://onboarding-businessapp.b2b.tp-local.com:3006",
    url: "onboarding",
    scope: "onboarding",
  },
  {
    path: "https://servicereviews-businessapp.b2b.tp-local.com:3007",
    url: "reviews",
    scope: "reviews",
  },
  {
    path: "https://upgrade-businessapp.b2b.tp-local.com:3009",
    url: "upgrade",
    scope: "upgrade",
  },
  {
    path: "https://businessupgrades-businessapp.b2b.tp-local.com:3010",
    url: "checkout",
    scope: "checkout",
  },
  {
    path: "https://company-settings.b2b.tp-local.com:3011",
    url: "company-settings",
    scope: "companySettings",
  },
  {
    path: "https://businessaccounts-plansandbilling.b2b.tp-local.com:3036",
    url: "plans-and-billing",
    scope: "plansandbilling",
  },
  {
    path: "https://applications-businessapp.b2b.tp-local.com:3014",
    url: "applications",
    scope: "applications",
  },
  {
    path: "https://businessusers-usermanagementbusinessapp.b2b.tp-local.com:3015",
    url: "usermanagement",
    scope: "usermanagement",
  },
  {
    path: "https://businessusers-profilebusinessapp.b2b.tp-local.com:3016",
    url: "account",
    scope: "account",
  },
  {
    path: "https://businessauthentication-samlbusinessapp.b2b.tp-local.com:3017",
    url: "saml",
    scope: "saml",
  },
  {
    path: "https://locations-businessapp.b2b.tp-local.com:3018",
    url: "locations",
    scope: "locations",
  },
  {
    path: "https://invitations-businessapp.b2b.tp-local.com:3019",
    url: "invitations",
    scope: "invitations",
  },
  {
    path: "https://reach-businessapp.b2b.tp-local.com:3020",
    url: "reach",
    scope: "reach",
  },
  {
    path: "https://reviewinsights-businessapp.b2b.tp-local.com:3021",
    url: "review-insights",
    scope: "reviewInsights",
  },
  {
    path: "https://statistics-v2businessapp.b2b.tp-local.com:3035",
    url: "analytics/explore",
    scope: "statisticsv2",
  },
  {
    path: "https://statistics-businessapp.b2b.tp-local.com:3022",
    url: "analytics",
    scope: "statistics",
  },
  {
    path: "https://tags-businessapp.b2b.tp-local.com:3023",
    url: "tags",
    scope: "tags",
  },
  {
    path: "https://emailwidgets-businessapp.b2b.tp-local.com:3024",
    url: "email-widgets",
    scope: "emailWidgets",
  },
  {
    path: "https://extwebhooks-businessapp.b2b.tp-local.com:3025",
    url: "webhooks",
    scope: "webhooks",
  },
  {
    path: "https://widgets-businessapp.b2b.tp-local.com:3026",
    url: "trustbox",
    scope: "trustbox",
  },
  {
    path: "https://imagegenerator-businessapp.b2b.tp-local.com:3027",
    url: "review-image",
    scope: "reviewImage",
  },
  {
    path: "https://marketing-businessapp.b2b.tp-local.com:3028",
    url: "marketing",
    scope: "marketing",
  },
  {
    path: "https://productreviews.b2b.tp-local.com:3030",
    url: "product-reviews",
    scope: "productReviews",
  },
  {
    path: "https://integrations-businessapp.b2b.tp-local.com:3031",
    url: "integrations",
    scope: "integrations",
  },
  {
    path: "https://share-businessapp.b2b.tp-local.com:3032",
    url: "share",
    scope: "share",
  },
  {
    path: "https://insights-businessapp.b2b.tp-local.com:3034",
    url: "insights",
    scope: "insights",
  },
].map(
  ({ scope, url, path }: { path: string; url: string; scope: string }): Remote => ({
    scope,
    url,
    path: `${(isDev && path) || `${window.location.origin}/${url}`}/remoteEntry.js`,
    module: "./App",
  }),
);

export const redirects = {
  "/categories": "/settings/categories",
  "/claim": claimPageUrl,
  "/reviews/reference": "/settings/reference",
  "/reported-reviews": "/reviews/reported-reviews",
  "/billing": "/plans-and-billing",
  "/company": "/plans-and-billing",
  "/labs": "/dashboard",
};
